
import axios from 'axios';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
// api
import ApiKey from '../api/ApiKey';
import BaseApi from '../api/BaseApi';
// components
import JSSidebar from './JSSidebar';
import Footer from '../element/Footer';
import NavBar from '../element/NavBar';
// helpers
import { logOutIfTokenExpired, resultInfo } from '../helpers';
// mui
import VisibilityIcon from '@mui/icons-material/Visibility';

const JSMailHistory = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('global');
  const userType = Cookies.get('user_type');
  const tokenKey = Cookies.get('tokenClient');

  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [mailHistory, setMailHistory] = useState(null);

  const mailPerPage = 10;

  const indexOfLastMail = currentPage * mailPerPage;
  const indexOfFirstMail = indexOfLastMail - mailPerPage;
  const currentData = mailHistory?.slice(indexOfFirstMail, indexOfLastMail);

  const handlePageChange = pageNumber => setCurrentPage(pageNumber);

  const getData = async () => {
    try {
      setLoading(true);

      const response = await axios.post(
        BaseApi + '/candidates/mailhistory',
        null,
        {
          headers: {
            key: ApiKey,
            token: tokenKey,
            contentType: 'application/json',
          },
        },
      );

      setLoading(false);

      if(response.data.status === 200) {
        setMailHistory(response.data.response);
      } else if (response.data.status === 400) {
        navigate('/');

        Cookies.remove('fname');
        Cookies.remove('user_id');
        Cookies.remove('user_type');
        Cookies.remove('tokenClient');

        resultInfo('warning', response.data.message, t('jobseekerExperience.close'));
      } else {
        resultInfo('error', response.data.message, t('jobseekerExperience.close'));
      }
    } catch (error) {
      setLoading(false);

      if (error.message === 'Network Error' || error.response.data.message === 'Token has expired') {
        navigate('/');

        logOutIfTokenExpired(t('tokenExpired.tokenExpired'), t('tokenExpired.close'));
      }

      console.error('Cannot get mail history of job seeker', error);
    }
  };

  useEffect(() => {
    if (userType === 'recruiter' || !tokenKey) {
      navigate('/auth/candidate-login');
    } else {
      getData();

      window.scrollTo(0, 0);
    }
  }, [tokenKey, navigate, userType]); // eslint-disable-line

  return (
    <>
      <NavBar />
      <div className='container paymentHistory'>
        <div className='row'>
          <div className='col-lg-3 col-md-3'>
            <JSSidebar />
          </div>
          {
            loading
              ? (
                <div className='loader-container' />
              ) : (
                <div className='col-lg-9 col-md-9 mb-5'>
                  <div className='PHHeader'>
                    <div className='d-flex PageHeader'>
                      <img src='/Images/employerSide/icon6color.png' alt='' />
                      <h3 className='ms-1' style={{ color: '#4464ac' }}>
                        {t('jobseekerMailHistory.mailHistory')}
                      </h3>
                    </div>
                    <div className='PHBody mt-5'>
                      <table className='table'>
                        <thead>
                          <tr className='table-active TrFirst'>
                            <th className='' scope='col p-3'>
                              {t('jobseekerMailHistory.username')}
                            </th>
                            <th className='' scope='col p-3'>
                              {t('jobseekerMailHistory.companyName')}
                            </th>
                            <th className='' scope='col p-3'>
                              {t('jobseekerMailHistory.subject')}
                            </th>
                            <th className='' scope='col p-3'>
                              {t('jobseekerMailHistory.created')}
                            </th>
                            <th className='' scope='col p-3'>
                              {t('jobseekerMailHistory.action')}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            currentData && currentData.map((i, index) => (
                              <tr key={index} className='TrDefoult'>
                                <td className=''>{i.user_name}</td>
                                <td className=''>{i.company_name}</td>
                                <td className=''>
                                  <Link to={`/candidates/maildetail/${i.slug}`}>
                                    {i.subject}
                                  </Link>
                                </td>
                                <td className=''>{i.created.substring(0, 10)}</td>
                                <td className='APActionButton'>
                                  <button
                                    className='btn btn-primary'
                                    onClick={() => navigate(`/candidates/maildetail/${i.slug}`)}
                                  >
                                    <VisibilityIcon />
                                  </button>
                                </td>
                              </tr>
                            ))
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className='JSMailHistoryPagination'>
                    <p className='text-muted empPaginationData'>
                      {t('pagination.NoofRecords')} {mailHistory?.length > 0 ? indexOfFirstMail + 1 : indexOfFirstMail}-
                      {mailHistory ? Math.min(indexOfLastMail, mailHistory?.length) : 0} of{' '}
                      {mailHistory ? mailHistory?.length : 0}
                    </p>
                    <div className='d-flex justify-content-center empPaginationButton'>
                      <button
                        className='navButton1 me-2'
                        disabled={currentPage === 1}
                        onClick={() => handlePageChange(currentPage - 1)}
                      >
                        {t('pagination.Prev')}
                      </button>
                      <button
                        className='navButton1'
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={indexOfLastMail >= mailHistory?.length}
                      >
                        {t('pagination.Next')}
                      </button>
                    </div>
                  </div>
                </div>
              )
          }
        </div>
      </div>

      <Footer />
    </>
  );
};

export default JSMailHistory;
